import React from 'react'
import Reflux from 'reflux'
// import axios from 'axios'
import { Link, withRouter } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'
import { Card, CardHeader, CardBody, Button, Container, Row, Col } from 'reactstrap'

import CurrentRecipeActions from '~/actions/currentRecipe.js'

import CurrentRecipeStore from '~/stores/currentRecipe.js'

import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
// import RecipeIngredientsAdd from '../recipeIngredients/add.jsx'
import RecipeDetailsYield from './yield.jsx'
import RecipeDetailsServings from './servings.jsx'
import RecipeDetailsPreheat from './preheat.jsx'
import RecipeDetailsDescription from './description.jsx'
import RecipeDetailsSource from './source.jsx'
import RecipeInstructionsView from '../recipeInstructions/view.jsx'
import RecipeIngredientsView from '../recipeIngredients/view.jsx'
import CategoryLabel from '../categoryLabel/index.jsx'
// import apiUtils from '../../helper/api.js'


class RecipeDetails extends Reflux.Component {
	constructor(props) {
		super(props)

		CurrentRecipeActions.reset()

		this.store = CurrentRecipeStore

		this.goToHomepage = this.goToHomepage.bind(this)
		this.dspBackButton = this.dspBackButton.bind(this)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	componentDidMount() {
		CurrentRecipeActions.get(this.props.match.params.recipeID)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	componentWillReceiveProps(nextProps) {
		CurrentRecipeActions.get(nextProps.match.params.recipeID)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	dspBackButton() {
		return (
			<Row>
				<Col>
					<Button onClick={this.goToHomepage} color="primary">
						<FontAwesome name="arrow-circle-left" /> Back to list
					</Button>
				</Col>
			</Row>
		)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	goToHomepage() {
		if (this.props.history.location.pathname !== '/') {
			this.props.history.push('/')
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const isLoaded = this.state.recipeID > 0
		const imgBase = '/assets/recipes/large'
		const theThumbSrc = (
			typeof this.state.filename !== 'undefined'
			&& this.state.filename !== ''
			&& this.state.filename !== null
		)
			? `${imgBase}/${this.state.filename}`
			: `${imgBase}/no-image.jpg`

		return (isLoaded)
			? (
				<Container fluid>
					<Row>
						<Col>
							<h2 style={{ marginTop: 0, borderBottom: '1px solid #ccc' }}>
								{ this.state.recipe }
								<CategoryLabel categoryID={this.state.categoryID} />
								<div className="float-right">
									<OnlyIfAuthorized>
										<Link to={`/recipe/${this.props.match.params.recipeID}/edit`}>
											<Button
												color="primary"
											>
												Edit
											</Button>
										</Link>

										{' '}

										<FontAwesome
											name="star"
											style={{ color: '#787878', cursor: 'pointer' }}
											onClick={() => alert('Favorites do not work yet')}
										/>
									</OnlyIfAuthorized>
								</div>
							</h2>
						</Col>
					</Row>

					<RecipeDetailsPreheat />

					<Row>
						<Col md={4}>
							<img className="img-fluid" src={theThumbSrc} alt={this.state.recipe} /><br />
						</Col>
						<Col md={6}>
							<em>
								(additional photos still in progress)
							</em>
						</Col>
						<Col md={2} className="d-flex">
							<Card className="flex-fill w-100 h-100">
								<CardHeader>Time</CardHeader>
								<CardBody className="flex-fill">
									<strong>{' Prep: '}{this.state.timePrep}</strong><br />
									<strong>{' Cook: '}{this.state.timeCook}</strong><br />
									<strong>{' Ready: '}{this.state.timeReady}</strong><br />
									<br />
									<strong>{' Total Time: '}{this.state.timePrep + this.state.timeCook + this.state.timeReady}</strong><br />
								</CardBody>
							</Card>
						</Col>
					</Row>

					<br />

					<RecipeDetailsDescription />

					<RecipeDetailsYield />

					<RecipeDetailsServings />

					<RecipeDetailsSource />

					<Row>
						<Col md={4}>
							<RecipeIngredientsView />
						</Col>
						<Col>
							<RecipeInstructionsView />
						</Col>
					</Row>

					{ this.dspBackButton() }

					<Row><Col>&nbsp;</Col></Row>
				</Container>
				)
			: <div>loading...</div>
	}
}

export default withRouter(RecipeDetails)



// WEBPACK FOOTER //
// ./src/modules/details/index.jsx